import { render, staticRenderFns } from "./r-smart-offer-bundle-christmas.vue?vue&type=template&id=44dcef5d"
import script from "./r-smart-offer-bundle-christmas.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-christmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44dcef5d')) {
      api.createRecord('44dcef5d', component.options)
    } else {
      api.reload('44dcef5d', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-christmas.vue?vue&type=template&id=44dcef5d", function () {
      api.rerender('44dcef5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-christmas/r-smart-offer-bundle-christmas.vue"
export default component.exports